<template>
  <div class="container-fluid">
    <h3 class="text-dark mb-4">{{ $tt(catlogname) }}</h3>
    <el-row>
      <el-col :span="2">
        <el-button v-if="role.AddProduct" @click="this.$router.back()">
          {{ $t("back") }}
        </el-button>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" v-if="role.AddProduct" @click="addItem">
          {{ $t("addproduct") }}
        </el-button>
      </el-col>
    </el-row>
    <div class="row">
      <el-pagination
        :current-page="currentPage"
        background
        layout="pager"
        :total="totalCount"
        :page-size="50"
        @current-change="refresh"
      >
      </el-pagination>
    </div>
    <div class="card shadow">
      <div class="card-body">
        <div
          id="dataTable"
          class="table-responsive table mt-2"
          role="grid"
          aria-describedby="dataTable_info"
          style="overflow-y: hidden"
        >
          <table id="dataTable" class="table my-0">
            <thead>
              <tr>
                <th style="width: 63px">{{ $t("index") }}</th>
                <th>
                  <span>{{ $t("model") }}</span>
                </th>
                <th style="width: 50px">{{ $t("picture") }}</th>
                <th>{{ $t("status") }}</th>
                <th>适用范围</th>
                <!-- <th>规格</th> -->
                <th style="max-width: 500px">{{ $t("descript") }}</th>
                <th style="max-width: 200px">{{ $t("remark") }}</th>
                <!-- <th>{{ $t("price") }}</th> -->
                <!--                <th>成本价格</th>-->
                <th>{{ $t("customerID") }}</th>
                <th>{{ $t("bikeID") }}</th>
                <th>认证</th>
                <th v-if="role.updateProduct">{{ $t("operate") }}</th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in TableData" :key="index">
              <tr style="height: 1px">
                <td>{{ index + 1 }}</td>
                <td style="font-weight: bold">{{ item.model }}</td>
                <td style="text-align: center">
                  <img
                    @click="imgViewClick(item)"
                    :src="item.picture"
                    style="height: 100px; cursor: pointer"
                  />
                </td>
                <td>{{ item.status }}</td>
                <td>{{ item.limit }}</td>
                <td>
                  <div style="max-width: 600px" v-html="item.description" />
                </td>
                <td style="max-width: 300px; white-space: pre-wrap; text-align: left">
                  {{ item.remark }}
                </td>
                <!-- <td>{{ item.price }}</td> -->
                <!--                <td>{{ item.cost }}</td>-->
                
                <td style="height: inherit; padding: 0">
                  <div style="height: 100%; display: flex; flex-direction: column">
                    <div
                      style="
                        flex: 1;
                        display: table;
                        margin-bottom: -1px;
                        border-bottom: 1px solid #e3e6f0;
                      "
                      :key="strs"
                      v-for="strs in splitStr(item.customerID)"
                    >
                      <div style="display: table-cell; vertical-align: middle">
                        {{ strs }}
                      </div>
                    </div>
                  </div>
                </td>
                <td style="height: inherit; padding: 0">
                  <div style="height: 100%; display: flex; flex-direction: column">
                    <div
                      style="
                        flex: 1;
                        display: table;
                        margin-bottom: -1px;
                        border-bottom: 1px solid #e3e6f0;
                      "
                      :key="strs"
                      v-for="strs in splitStr(item.bikeID)"
                    >
                      <div style="display: table-cell; vertical-align: middle">
                        {{ strs }}
                      </div>
                    </div>
                  </div>
                </td>
                <td>{{ item.certification }}</td>
                <td v-if="role.updateProduct">
                  <a href="javascript:;" @click="UpdateClick(item)">{{ $t("update") }}</a>
                  <a href="javascript:;" @click="Delete(item)" style="margin: 0 10px 0">{{
                    $t("delete")
                  }}</a>
                </td>
              </tr>
              <!-- <tr>
                <transition v-show="item.ShowDes" name="el-zoom-in-top">
                  <td colspan="10">
                    <rich-text-box-shower :text="item.description"></rich-text-box-shower>
                  </td>
                </transition>
              </tr> -->
            </tbody>
            <tfoot>
              <tr></tr>
            </tfoot>
          </table>
        </div>
        <div class="row">
          <el-pagination
            :current-page="currentPage"
            background
            layout="pager"
            :total="totalCount"
            :page-size="50"
            @current-change="refresh"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
  <!-- <el-dialog :fullscreen="true" v-model="showImgDialog">
    <img :src="showingImgSrc">
  </el-dialog> -->
</template>

<script>
import { ChangePrice, DeleteProducts, GetProductPages } from "../common/httphelper.js";
import Swal from "sweetalert2";
import router from "../router/index.js";
import "../common/role";
import getRole from "../common/role";

export default {
  // components: { RichTextBoxShower },
  data() {
    return {
      currentPage: 1,
      catlogname: "",
      catlogid: "",
      TableData: [],
      totalCount: undefined,
      role: {},
    };
  },
  methods: {
    imgViewClick(item) {
      this.$viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: this.TableData.indexOf(item),
        },
        images: this.TableData.map((item) => item.picture),
      });
    },
    addItem() {
      router.push({
        name: "AddProduct",
        query: { id: this.catlogid, name: this.catlogname },
      });
    },
    refresh(index = 1) {
      window.scrollTo(0, 0);
      GetProductPages(this.catlogid, index).then((res) => {
        Swal.close();
        this.TableData = res.data.data;
        this.totalCount = res.data.count;
        this.currentPage = index;
      });
    },
    Delete(item) {
      Swal.fire({
        title: "确定删除吗?",
        text: "将创建删除操作的审批流程!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.isConfirmed) {
          DeleteProducts(item.id).then(async (res) => {
            if (res.data.data) {
              await Swal.fire({
                icon: "success",
                title: "创建审批流程成功",
                showConfirmButton: false,
                timer: 1500,
              });
            } else {
              await Swal.fire({
                icon: "error",
                title: res.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          });
        }
      });
    },
    splitStr(str) {
      if (!str) {
        return ["/"];
      } else {
        console.log(str);
        return str.split("/");
      }
    },
    UpdateClick(item) {
      router.push({
        name: "AddProduct",
        query: {
          id: this.catlogid,
          name: this.catlogname,
          item: JSON.stringify(item),
        },
      });
    },
  },
  mounted() {
    this.catlogname = this.$route.query.name;
    this.catlogid = this.$route.query.id;
    this.role = getRole();
    this.refresh();
  },
};
</script>

<style scoped>
.table > :not(:first-child) {
  border-top: 1px solid currentColor;
}
</style>
